export const optionStyles = {
    options: { primaryColor: '#3498db', width:420}
}
export const locale = (t) => ({
    back: t('features.GuideTour.Button.back'),
    last: t('features.GuideTour.Button.close'),
    next: t('features.GuideTour.Button.next'),
    skip: t('features.GuideTour.Button.skip'),
})


export const optionStylesStep2 = {
    options: { primaryColor: '#3498db', width:420},
    buttonSkip: {
        display: 'none'
    }
}